import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-print-modal',
  templateUrl: './print-modal.component.html',
  styleUrls: ['./print-modal.component.scss']
})
export class PrintModalComponent implements OnInit {

  polygons: boolean = true;
  data: boolean = true;
  table: boolean = false;

  selectedOpts = {
    polygons: false,
    data: false,
    table: false
  };

  constructor(
    private ref: DynamicDialogRef, 
    private config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {

  }

  onConfirm() {
    this.selectedOpts.data = this.data;
    this.selectedOpts.polygons = this.polygons;
    this.selectedOpts.table = this.table;
    this.ref.close(this.selectedOpts);
  }

  onClose() {
    this.ref.close();
  }

}
